import type { Counts, Level, Observatory, PlayerState } from '@astrasonora/annotation-schema'

export type { PlayerState }

export function emptyPlayerState(playerId: string): PlayerState {
  return {
    playerId,
    profile: { labelStyle: 'roman' },
    night: { unlocked: 1, lastOffered: {} },
    songs: {},
    functionStats: {},
    transitionStats: {},
  }
}

/** The song last offered at a night in an observatory, or null. */
export function lastOffered(state: PlayerState, o: Observatory, n: Level): string | null {
  return state.night.lastOffered[o]?.[String(n)] ?? null
}

export const zeroCounts = (): Counts => ({ correctLive: 0, correctPause: 0, wrong: 0 })

/** How many answers a statistic counts, right or wrong. */
export const answered = (c: Counts): number => c.correctLive + c.correctPause + c.wrong

/** The share of a statistic's answers that were right, live or after the pause; 0 for none. */
export function successRatio(c: Counts): number {
  const n = answered(c)
  return n ? (c.correctLive + c.correctPause) / n : 0
}

/** The key of a statistic: the observatory and a cell, or a transition between two cells (spec §10). */
export function statKey(observatory: Observatory, key: string): string {
  return `${observatory}:${key}`
}

/** Splits a statistic key into its observatory and the rest; cells contain a colon themselves. */
export function splitStatKey(key: string): { observatory: Observatory; rest: string } | null {
  const i = key.indexOf(':')
  if (i < 0) return null
  const observatory = key.slice(0, i)
  if (observatory !== 'major' && observatory !== 'minor') return null
  return { observatory, rest: key.slice(i + 1) }
}
